import * as NUMBER from 'constant/number'
import * as TABLE from 'constant/table'
import React, { useState } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Modal, Table, Col, Row } from 'antd'
import _ from 'lodash'
import PropTypes from 'prop-types'
import ReactDragListView from 'react-drag-listview'
import { closeSubTable } from 'action/table'
import { saveCategoriesOrder } from 'action/category'
import SubTable from './sub-table'

const getCategories = (categories, site) => (categories.map((category) => {
  if (category.site_uuid === site.uuid) {
    return { name: category.name, order: category.order, sub_categories: category.sub_categories, uuid: category.uuid }
  }
  return null
}))

// eslint-disable-next-line max-lines-per-function
export const OrderCategories = ({ site, columns, categories, show, subCategories, category, closeSubTable, saveCategoriesOrder, loading }) => {
  const [visible, setVisible] = useState(false)
  const siteCategories = getCategories(categories, site)
  const [dataSource, setDataSource] = useState(_.compact(siteCategories))

  const dragProps = {
    handleSelector: 'a',
    onDragEnd (fromIndex, toIndex) {
      const data = dataSource
      setDataSource()
      const item = data.splice(fromIndex - NUMBER.ONE, NUMBER.ONE)[0]
      data.splice(toIndex - NUMBER.ONE, NUMBER.ZERO, item)
      setDataSource(data)
    }
  }

  const handleSubmit = async () => {
    await saveCategoriesOrder(dataSource)
    setVisible(false)
  }

  const handleClick = () => setVisible(true)
  return (
    <>
      <a onClick={handleClick}>Order Site Categories</a>
      {show
      ? <SubTable />
      : <>
        <Modal
          bodyStyle={{
            backgroundColor: '#F7F7F7'
          }}
          confirmLoading={loading}
          okText='Save'
          onCancel={() => {
            setVisible(false)
          }}
          onOk={handleSubmit}
          title='Order Site Categories'
          visible={visible}
        >
          <Row>
            <Col
              span={24}
            >
              {getTable(dragProps, columns, dataSource)}
            </Col>
          </Row>
        </Modal>
      </>
      }
    </>
  )
}

const getTable = (dragProps, columns, dataSource) => (
  <>
    <ReactDragListView {...dragProps}>
      <Table
        columns={_.values(columns[TABLE.ORDER_CATEGORIES])}
        dataSource={dataSource}
        pagination={false}
        rowKey={({ uuid }) => uuid}
        scroll={{ x: TABLE.SCROLL, y: TABLE.SCROLL_DOWN }}
      />
    </ReactDragListView>
  </>

)

OrderCategories.propTypes = {
  categories: PropTypes.array,
  category: PropTypes.object,
  className: PropTypes.string,
  closeSubTable: PropTypes.func,
  columns: PropTypes.object,
  index: PropTypes.number,
  loading: PropTypes.bool,
  saveCategoriesOrder: PropTypes.func,
  show: PropTypes.bool,
  site: PropTypes.object,
  subCategories: PropTypes.array,
  subLoading: PropTypes.bool
}

export default connect(
  (state) => ({
    categories: state.category.categories,
    category: state.table.showSubTable.category,
    columns: state.table.shownColumns,
    loading: state.loader.loading,
    show: state.table.showSubTable.show,
    subCategories: state.table.showSubTable.sub_categories,
    subLoading: state.loader.categorySubmitting
  }),
  (dispatch) => ({
    closeSubTable: bindActionCreators(closeSubTable, dispatch),
    saveCategoriesOrder: bindActionCreators(saveCategoriesOrder, dispatch)
  })
)(OrderCategories)
